import { ParsedTree } from "./traversers/ParsedTree";
import { FunctionGenerator } from "./traversers/FunctionGenerator";
import { ExpressionStringGenerator } from "./traversers/ExpressionStringGenerator";
import { DependenciesController } from "./DependenciesController";
import { ParamType } from "../poly/ParamType";
export class ExpressionManager {
  constructor(param) {
    this.param = param;
    this.parse_completed = false;
    this.parse_started = false;
    this.parsed_tree = new ParsedTree();
    this._functionGenerator = new FunctionGenerator(this.param);
    this.dependencies_controller = new DependenciesController(this.param);
  }
  parseExpression(expression) {
    if (this.parse_started) {
      throw new Error(`parse in progress for param ${this.param.path()}`);
    }
    this.parse_started = true;
    this.parse_completed = false;
    this.parsed_tree = this.parsed_tree || new ParsedTree();
    this.reset();
    if (this.param.type() == ParamType.STRING) {
      this.parsed_tree.parse_expression_for_string_param(expression);
    } else {
      this.parsed_tree.parse_expression(expression);
    }
    this._functionGenerator.parse_tree(this.parsed_tree);
    if (this._functionGenerator.error_message() == null) {
      this.dependencies_controller.update(this._functionGenerator);
      if (this.dependencies_controller.error_message) {
        this.param.states.error.set(this.dependencies_controller.error_message);
      } else {
        this.parse_completed = true;
        this.parse_started = false;
      }
    }
  }
  async computeFunction() {
    if (this._computeAllowed()) {
      try {
        const newValue = await this._functionGenerator.evalFunction();
        return newValue;
      } catch (e) {
      }
    } else {
    }
  }
  reset() {
    this.parse_completed = false;
    this.parse_started = false;
    this.dependencies_controller.reset();
    this._functionGenerator.reset();
  }
  is_errored() {
    return this._functionGenerator.is_errored();
  }
  error_message() {
    return this._functionGenerator.error_message();
  }
  _computeAllowed() {
    return this._functionGenerator.evalAllowed();
  }
  updateFromMethodDependencyNameChange() {
    this.expression_string_generator = this.expression_string_generator || new ExpressionStringGenerator(this.param);
    const new_expression_string = this.expression_string_generator.parse_tree(this.parsed_tree);
    if (new_expression_string) {
      this.param.set(new_expression_string);
    } else {
      console.warn("failed to regenerate expression");
    }
  }
}
